// src/components/KPISection.jsx
import { useEffect, useState } from "react"
import api from "../services/api"
import toast from "react-hot-toast"

export default function KPISection() {
  const [kpis, setKpis] = useState([
    {
      title: "Total Submissions",
      value: 0,
      pct: "+0%",
      color: "bg-green-100 text-green-700"
    },
    {
      title: "Total Approvals",
      value: 0,
      pct: "+0%",
      color: "bg-green-100 text-green-700"
    },
    {
      title: "Overdue",
      value: 0,
      pct: "0%",
      color: "bg-red-100 text-red-600"
    },
    {
      title: "Total Reviewers",
      value: 0,
      pct: "+0%",
      color: "bg-green-100 text-green-700"
    }
  ]);

  useEffect(() => {
    fetchKPIs();
  }, []);

  const fetchKPIs = async () => {
    try {
      const res = await api.get("/esmp/list");
      
      if (!res.data.success) return;

      const data = res.data.data;

      const totalSubmissions = data.length;

      const totalApprovals = data.filter(
        item => item.status === "Approved"
      ).length;

      const overdue = data.filter(
        item => item.status === "Overdue"
      ).length;

      // ✅ Unique reviewers count
      const reviewers = new Set(
        data
          .map(item => item.reviewer_id)
          .filter(Boolean)
      );

      const totalReviewers = reviewers.size;

      setKpis([
        {
          title: "Total Submissions",
          value: totalSubmissions,
          pct: "+0%",
          color: "bg-green-100 text-green-700"
        },
        {
          title: "Total Approvals",
          value: totalApprovals,
          pct: "+0%",
          color: "bg-green-100 text-green-700"
        },
        {
          title: "Overdue",
          value: overdue,
          pct: "0%",
          color: "bg-red-100 text-red-600"
        },
        {
          title: "Total Reviewers",
          value: totalReviewers,
          pct: "+0%",
          color: "bg-green-100 text-green-700"
        }
      ]);
    } catch (err) {
      console.error("KPI error:", err);
      toast.error("Failed to load KPIs");
    }
  };

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {kpis.map((item, i) => (
        <div
          key={i}
          className="bg-white rounded-xl shadow hover:shadow-xl transition p-5 border-l-4 border-green-600"
        >
          {/* Title */}
          <p className="text-sm text-gray-500 mb-1">
            {item.title}
          </p>

          {/* Main Value */}
          <h2 className="text-3xl font-bold text-gray-800">
            {item.value}
          </h2>

          {/* Percentage Badge */}
          <div className="mt-3">
            <span
              className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${item.color}`}
            >
              {item.pct}
            </span>
          </div>
        </div>
      ))}
    </section>
  )
}